import React from "react";
import { useMediaQuery, Box, Typography, Paper, Fade, List, ListItem, ListItemText } from "@mui/material";
import AlarmIcon from "@mui/icons-material/Alarm"; // relevant icon
import JavascriptTutorialsSlides from "./JavascriptTutorialsSlides";

const JavascriptTutorials = () => {
    const isMobile = useMediaQuery("(max-width:600px)");

    return (
        <Fade in={true} timeout={1000}>
            <Paper
                elevation={4}
                sx={{
                    mb: 3,
                    width: "100%",
                    p: isMobile ? 2 : 4,
                    borderRadius: 2,
                    textAlign: "left",
                    boxShadow: "0 6px 12px rgba(0,0,0,0.1)",
                    background: "linear-gradient(90deg, #f7e600, #daa520)",
                }}
            >
                {/* Header */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mb: 3,
                    }}
                >
                    <AlarmIcon sx={{ fontSize: 32, color: "#100720", mr: 1 }} />
                    <Typography
                        variant={isMobile ? "h6" : "h5"}
                        sx={{
                            fontWeight: 700,
                            color: "#100720",
                            textTransform: "uppercase",
                            fontFamily: "'Roboto', sans-serif",
                        }}
                    >
                        Learning Objectives
                    </Typography>
                </Box>

                {/* Content */}
                <Box sx={{ textAlign: "left", wordSpacing: "1.5px" }}>
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 600,
                            mb: 2,
                            fontFamily: "'Roboto', sans-serif",
                            color: "#100720",
                        }}
                    >
                        1. Objectives
                    </Typography>

                    <Typography
                        variant="body1"
                        sx={{
                            mb: 2,
                            fontFamily: "'Roboto', sans-serif",
                            color: "#100720",
                            lineHeight: 1.6,
                        }}
                    >
                        React is simply a JavaScript library for building scalable frontend applications. It is also
                        very important to have in-depth knowledge of what this library is. You can think of it as
                        collections of classes and methods (JavaScript In-built Functions) for building Frontend
                        Applications. Things to know before diving into building Frontend Applications:
                    </Typography>

                    {/* Objectives List */}
                    <List sx={{ pl: 2 }}>
                        {[
                            "How to declare and assign variables in JavaScript",
                            "Know the difference between let and const",
                            "Be able to write JavaScript functions, with parameters",
                            "Be able to use and manipulate objects",
                            "How to use the 'this' keyword",
                            "Manipulate HTML elements with JavaScript",
                            "How to fetch data in JavaScript",
                            "Understand and how to use array methods: map, filter, find",
                            "Able to write React functional components with hooks",
                            "Understand software architecture style, NodeJS",
                            "NodeJS principle: single thread, non-blocking IO",
                            "Create a simple server using NodeJS or Express",
                        ].map((item, index) => (
                            <ListItem key={index} sx={{ py: 0 }}>
                                <ListItemText
                                    primary={item}
                                    primaryTypographyProps={{
                                        fontFamily: "'Roboto', sans-serif",
                                        fontSize: "0.95rem",
                                        color: "#100720",
                                    }}
                                />
                            </ListItem>
                        ))}
                    </List>

                    <Typography
                        variant="body1"
                        sx={{
                            mt: 2,
                            fontFamily: "'Roboto', sans-serif",
                            color: "#100720",
                            lineHeight: 1.6,
                        }}
                    >
                        Understanding all these above are needed to be a MongoDB‑Express‑React‑Nodejs{" "}
                        <strong>(MERN‑STACK FULLSTACK)</strong> Developer.
                    </Typography>
                </Box>
            </Paper>
        </Fade>
    );
};

export default JavascriptTutorials;
